module.exports = __webpack_public_path__ + "static/Factset-e09879f4cf85a1e2f05e381b210633c3.png";